import { definePermissions } from '@eis/core';

/**
 * Claims permission catalog (SDD-018 C-13; modules/claims/PERMISSIONS.md).
 *
 * This file is the ONLY place in the module where permission literals may appear — ESLint enforces
 * that. The domain is claimservice's own: the image guards its routes with
 * `claim-management.claims.view` / `.create` (its OpenAPI document names them under "Required
 * Permissions"), and these keys are those, spelled in the platform's dotted grammar. The console
 * gate is UX; the service is the wall.
 */
export const claimsPermissions = definePermissions({
  claims: {
    domain: 'claim-management',
    entity: 'claims',
    actions: ['view', 'create'],
  },
});
